import React from 'react';
import { ICONS } from './icons';

const PageHeader = ({ title, subtitle, children, className = '' }) => {
  return (
    <div className={` ${className}`}>
      <div className="header-left d-flex flex-row align-items-center gap-2">
        <img src={ICONS.LOGO} alt="Logo" className="header-logo" />
        <div>
          <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
      </div>

      {children && (
        <div className="page-header-actions">
          {children}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
